
import { CONTRACT_INDEX_PAYROLL_ACCOUNT, CHECKING_ACCOUNT } from "constants/index"

export const REDIRECT_TO_UPDATE_FIOC_URL = '/myprofile/fioc'
export const REDIRECT_TO_UPDATE_DOCUMENT_ID_URL = '/myprofile/documentation/uploadDocumentation'

export const POE_KEY = {
    [CONTRACT_INDEX_PAYROLL_ACCOUNT]: {
        title: 'contractsView-fiocRequired_payrollAccountModalTitle',
        description: 'contractsView-fiocRequired_payrollAccountModalDescription',
        documentationDescription: 'contractsView-fiocRequired_payrollAccountModalDocumentationDescription'
    },
    [CHECKING_ACCOUNT]: {
        title: 'contractsView-fiocRequired_checkingAccountModalTitle',
        description: 'contractsView-fiocRequired_checkingAccountModalDescription',
        documentationDescription: 'contractsView-fiocRequired_checkingAccountModalDocumentationDescription'
    }
}
